<div class="form-layout" [class.form-layout--two-col]="twoColumn" [attr.data-max]="maxWidth" [attr.data-pad]="padding">
  @if (showBackTop) {
    <app-back-to-top [visibilityHeight]="100"></app-back-to-top>
  }

  <div class="form-layout__rail">
    @if (showHeader) {
      <div class="form-layout__header">
        <app-form-header [form]="form" (goBackEvent)="goBackEvent.emit()"></app-form-header>
        <ng-content select="[formLayoutError]"></ng-content>
      </div>
    }

    <div class="form-layout__body">
      <div class="form-layout__main">
        <ng-content></ng-content>
      </div>
      @if (twoColumn) {
        <aside class="form-layout__aside">
          <ng-content select="[formLayoutAside]"></ng-content>
        </aside>
      }
    </div>

    <ng-content select="[formLayoutFooter]"></ng-content>
  </div>
</div>
